import React from 'react';
import { Container, Heading } from './styles';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import FooterMenu from '../../components/FooterMenu';
import SignupForm from '../../components/SignUpForm';
import SignupComplete from '../../components/SignupComplete';
import images from '../../config/images'
import { checkAdmin,checkMobile,checkPad  } from '../../lib';

class Register extends React.Component {
  state = {
    trialSignup: false,
    expiryDays: ''
  }
  setTrialSignup = (trialSignup,expiryDays) => {
    this.setState({
      trialSignup,
      expiryDays
    })
  }
  render(){
  const {signupUser,signupStatus,user,hasErrorOccured,errors,recieveSignupstatus} = this.props
  let style = {}
  let containerStyle ={}
  let mainDiv = {}
  let mobiledesign = {}
  if(this.state.trialSignup){
    style = {
      backgroundColor: '#ffffffba',
      width: checkPad() ? '75%' : !checkMobile() ? '55%' : '',
      borderRadius:'13px'
    } 
    containerStyle={
      flex:1,
      marginTop: checkPad() ? '27%' : '',
      transform: (!checkMobile()) && 'translate(25%, 0px)',
      padding: '15px',
      width: (checkMobile() || checkPad()) && '100%',
      marginLeft: checkPad() && '19%'
    }
    mainDiv = {
      flex:1,
      flexDirection: (checkMobile() || checkPad()) ? 'column' : 'row'
    }
  }
  if(checkMobile()){
    mobiledesign = {
      padding: '60px 0',
      textAlign: 'center',
      fontSize: '31px',
      display: 'block'
    } 
  } 
  else if(checkPad()){
    mobiledesign = {
      fontSize: '40px'
    }  
}
  else {
    mobiledesign = {
      width: '55%',
      textAlign: 'center',
      display: 'inline-block',
      fontSize: '42px'
    } 
  }  
    
  return (
    <div className="flex justify-center flex-column items-center h-100" style={mainDiv}>
    {this.state.trialSignup && <Container style={{flex:1}}></Container>}
    <Container style={containerStyle}>
      <Heading className="flex items-center pr1" style={mobiledesign}>
          {this.state.trialSignup && <div>
          <div style={{color: '#f77719',display: !checkMobile() && 'inline-block',padding: '3px' , fontWeight: "900"}}>{this.state.expiryDays}日間</div>
            <div style={{color: '#145054',display: !checkMobile() && 'inline-block', fontWeight: "900"}}>無料トライアル</div>
          </div> 
          }
      </Heading>
      <Paper zDepth={3} style={style}>
        <div className="pa3">
          <div className="flex justify-between mb2">
          {!this.state.trialSignup && 
            <Link to={'/'}>
              <IconButton>
                <ArrowBack color="#afb8c5" /> }
              </IconButton>
            </Link> }
            <Heading trial={this.state.trialSignup} className="flex items-center pr1" style={{fontSize: checkMobile() ? '24px' : '25px' }}>
              {!signupStatus ? (
                this.state.trialSignup ? '新規アカウント作成' : <FormattedMessage id="signUp.heading" />
              ) : (
                this.state.trialSignup ? '作成に成功しました。' : <FormattedMessage id="signUp.doneHeading" />
              )}
            </Heading>
            
          </div>
          {!signupStatus ? (
            <SignupForm
              {...this.props}
              errors={errors}
              signupUser={signupUser}
              authErrors={this.props.authErrors}
              setTrialSignup={this.setTrialSignup}
            />
          ) : (
            <SignupComplete
              location={this.props.location.pathname}
              recieveSignupstatus={recieveSignupstatus}
              user={user}
            />
          )}
        </div>
      </Paper>
      {!this.state.trialSignup && <FooterMenu /> }
      {this.state.trialSignup &&  <div className='h-100 pl3 flex justify-around flex-column' style={{padding:'5px', width: checkPad() ? '75%' : !checkMobile() ? '55%' : '', alignItems: 'flex-end'}}>
        <img src={images.anets_logo} alt="anets_logo" style={{width: 175, cursor: 'pointer'}}/>
      </div>}
    </Container>
  </div>
    )
  }
}
export default Register;


// WEBPACK FOOTER //
// src/routes/SignUp/SignUp.js